import React, {useEffect, useState} from "react";
import "../General/General.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import CancelModal from "../General/Cancel";
import "./AddServiceRequest.css";
import {useLocation, useNavigate} from "react-router-dom";
import {InputAdornment, Select, TextField} from "@mui/material";
import Stack from "@mui/material/Stack";
import {Tooltip} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import keycloak from "../../Keycloak";
import HarvestProjectSearch from "../General/HarvestProjectSearch";
import CircularProgress from '@mui/material/CircularProgress';
import JiraProjectSearch from "../General/JiraProjectSearch";
import Grid from "@mui/material/Grid";
import DragAndDrop, {uploadedFiles} from "../DragAndDrop";
import {showSaveError, showSaveSuccessMessage} from "../toastUtils";

const projectType = [
    {
        value: 0,
        label: "Team Augmentation",
    },
    {
        value: 1,
        label: "Fixed Cost Project",
    },
    {
        value: 2,
        label: "Support & Maintenance",
    },
    {
        value: 3,
        label: "Dedicated Product Development Team",
    },
    {
        value: 4,
        label: "Time & Materials",
    },

];

const rollOverRules = [
    {
        value: 0,
        label: "Expires",
    },
    {
        value: 1,
        label: "Rolls Over",
    },
];

const rollOverHoursType = [
    {
        value: 0,
        label: "Remaining Hours in Month",
    },
    {
        value: 1,
        label: "% of Remaining Hours in Month",
    },
];

const expiryType = [
    {
        value: 0,
        label: "Current month",
    },
    {
        value: 1,
        label: "Service Request end date",

    },
];

const invoicingRule = [
    {
        value: 0,
        label: "In Advance",
    },
    {
        value: 1,
        label: "In Arrears",
    },
];

const notify = [
    {
        value: "Webtonic System Admin",
        label: "Webtonic System Admin",
    }, {
        value: "Webtonic Account Manager",
        label: "Webtonic Account Manager",
    }, {
        value: "Webtonic Delivery Manager",
        label: "Webtonic Delivery Manager",
    }, {
        value: "Webtonic Basic",
        label: "Webtonic Basic",
    }, {
        value: "Client Admin",
        label: "Client Admin"
    }, {
        value: "Client Basic",
        label: "Client Basic",
    },
];

const style = {
    "& label.Mui-focused": {
        color: "#EC8D2B",
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: "#EC8D2B",
        },
    },
};

export function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsArrayBuffer(file);
    });
}


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 50,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const AddServiceRequest = () => {
    const navigate = useNavigate();
    const [enableSave, setEnableSave] = useState(false);
    const jiraProjectId = localStorage.getItem('jiraProjectId');
    const projectId = localStorage.getItem('projectId');
    const [projectTypeValue, setProjectType] = useState(0);
    const [rollOverRulesValue, setRollOverRules] = useState(0);
    const [expiryDateValue, setExpiryType] = useState(0);
    const [invoicingRuleValue, setInvoicingRule] = useState(0);
    const [rollOverHoursTypeValue, setRollOverHoursType] = useState(0);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const clientId = searchParams.get('clientId');
    const harvestClientId = searchParams.get('harvestClientId');
    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    const [data, setServiceRequestData] = useState({
        id: 0,
        alertThreshold: 0,
        daysInArrears: "",
        invoicingRule: 0,
        notifyee: personName,
        projectType: "",
        rollover: "",
        clientId: clientId,
        jiraProjectId: jiraProjectId,
        projectId: projectId,
        serviceRequestId: 0,
        client: {
            clientId: 0,
        },
        harvestProject: {
            id: 0,
            name: "",
            clientId: harvestClientId,
            clientName: "",
            startsOn: "",
            endsOn: "",
            budget: "",
        },
        jiraProject: {
            id: 0,
            name: "",
            createdAt: "",
        },
        documents: [
            {
                fileName: "",
                fileType: "",
                fileBytes: null
            }
        ]
    });

    const assignPartialObject = (existingObject, newObject) => {
        return Object.assign(existingObject, newObject);
    }

    const fieldsOnChange = function (e) {
        let {name, value} = e.target;
        if(e.target.name === "projectType") {
            setProjectType(e.target.value);
        } else if (e.target.name === "rollover"){
            setRollOverRules(e.target.value);
        } else if (e.target.name === "expiryType") {
            setExpiryType(e.target.value);
        } else if (e.target.name === "invoicingRule") {
            setInvoicingRule(e.target.value);
        } else if (e.target.name === "rollOverHoursType") {
            setRollOverHoursType(e.target.value);
        }
        console.log("target name" + e.target.name);

        if (name.includes(".")) {
            const [nestedObject, nestedProperty] = name.split(".", 2);

            value = assignPartialObject(data[nestedObject], {[nestedProperty]: value});
            name = nestedObject;
        }

        setServiceRequestData({...data, [name]: value})
        console.log(data);
        setEnableSave(true);
    }

    const [openModal, setOpenModal] = useState(false);
    const [isShowSpinner] = useState(false);
    const messageForCompulsaryFields = "Please complete the compulsory fields on the form below"
    const [saveClicked, setSaveClicked] = useState(false);
    const createNewServiceRequest = async (event) => {
        event.preventDefault();
        console.log(data);
        if (data.daysInArrears === 0) {
            data.daysInArrears = "";
        }
        if ((data.daysInArrears < 1 || data.daysInArrears > 29) && data.daysInArrears !== "") {
            showSaveError("Please check Harvest and enter the days in arrears rule between 1-29")
            console.log("arrears not between 1-29");
        } else {
            if (saveClicked) {
                if (data.harvestProject.value === '') {
                    showSaveError(messageForCompulsaryFields);
                    window.scrollTo(0, 0);
                    document.getElementById('harvestProject').focus();
                } else if (data.alertThreshold === '') {
                    showSaveError(messageForCompulsaryFields);
                    window.scrollTo(0, 0);
                    document.getElementById('alertThreshold').focus();
                } else if (!openModal) {
                    try {
                        const headers = new Headers();
                        headers.append('Authorization', 'Bearer ' + keycloak.token);
                        headers.append('Content-Type', 'application/json')

                        if (uploadedFiles) {
                            if (uploadedFiles.length > 0) {
                                for (const element of uploadedFiles) {
                                    const file = element;
                                    const fileBytes = await readFileAsArrayBuffer(file);
                                    data.documents[0].fileName = file.name;
                                    data.documents[0].fileType = file.type;
                                    data.documents[0].fileBytes = Array.from(new Uint8Array(fileBytes))
                                }
                            }
                        } else {
                            data.documents = [];
                        }

                        data.notifyee = data.notifyee.toString();
                        if (data.daysInArrears === "") {
                            data.daysInArrears = 0;
                        }

                        const response = await fetch("api/service-request", {
                            method: "POST",
                            body: JSON.stringify(data),
                            headers: headers,
                        });

                        if (response.ok) {
                            const data = await response.json();
                            console.log(data);
                            console.log('All required fields filled in');
                            showSaveSuccessMessage("New service request has been added successfully");
                            navigate("/ClientList");
                        } else {
                            const error = await response.text();
                            console.log(error)
                            showSaveError("This service request has already associated with this client");
                        }
                    } catch (err) {
                        console.log("try...catch: ", err);
                        showSaveError("An error occurred, please try again");
                        window.scrollTo(0, 0);
                    }
                }
            }
        }
    };


    let stackSpace2;
    let durationWidth;
    if (window.innerWidth >= 1024) {

        stackSpace2 = 15;
    } else if (window.innerWidth > 480 && window.innerWidth < 1024) {

        stackSpace2 = 15;
    } else {

        stackSpace2 = 12;
    }

    const DisplayRollOverRules = (event) => {
        const showRollOverHoursDiv = document.getElementById("showRollOverHoursDiv");
        const showExpiryTypeDiv = document.getElementById("showExpiryTypeDiv");

        if (rollOverRulesValue === 1) {
            showRollOverHoursDiv.style.display = "none";
            showExpiryTypeDiv.style.display = "block";
        } else {
            showExpiryTypeDiv.style.display = "none";
            showRollOverHoursDiv.style.display = "block";
        }

        fieldsOnChange(event);
    };

    const CheckArrearDays = (event) => {
        let value = Number(event.target.value);

        if (value > 29) {
            value = 29;
            event.target.value = value;
        } else if (value < 1) {
            value = 1
            event.target.value = value;
        }

        if (value < 1) {
            document.getElementById("Arrears").style.color = "red";
        } else {
            document.getElementById("Arrears").style.color = "black";
        }

        fieldsOnChange(event);
    };

    const ShowInvoicingRule = (event) => {
        const value = event.target.value

        console.log(value);

        const daysInArrearsDiv = document.getElementById("daysInArrearsDiv");
        if (value === 1) {
            daysInArrearsDiv.style.display = "block";
        } else {
            daysInArrearsDiv.style.display = "none";
            daysInArrearsDiv.value = 0;
        }
        fieldsOnChange(event);
    }

    const NotifyHandleChange = (event) => {
        const {target: {value}} = event;
        setPersonName(typeof value === 'string' ? value.split(',') : value);
        fieldsOnChange(event);
    };

    const jiraFieldChange = (event) => {
        data.jiraProjectId = event;
        console.log("jiraFieldChange", event);
        console.log(data);
        setEnableSave(true)
    };

    const harvestFieldChange = (event) => {
        data.projectId = event;
        console.log("harvestFieldChange", event);
        setEnableSave(true)
    };

    useEffect(() => {
        const selectedClientName = localStorage.getItem('selectedClientName');
        if (selectedClientName) {
            document.getElementById("clientName").value = selectedClientName;
        }
    }, []);

    return (
        <div data-testid='OuterMostDiv' className="OuterMostDiv outerMostDivContainer">
            <div>
                <form data-testid='Form' onSubmit={createNewServiceRequest}>
                    <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"} spacing={2}
                          className="gridPadding">
                        <Grid item xs={2}></Grid>
                        <Grid item xs={8}>
                            <h4 className="AddNewClientHeading" data-testid='AddNewServiceRequestHeading'> Add service
                                request</h4>
                        </Grid>
                        <Grid item xs={2}></Grid>

                        <Box xs={12} className="box-formatting">
                            <Paper className="Paper cardWidth elevation1" elevation={1} style={{height: "325px"}}>
                                <div className="HeadingTypography">Basic details</div>
                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            disabled
                                            id="clientName"
                                            label="Client name"
                                            defaultValue="Client name"
                                            name="clientName"
                                        />
                                    </Grid>
                                    <Grid item xs={12} data-testid='HarvestProjectSearchBox'>
                                        <HarvestProjectSearch harvestClientId={data.harvestProject.clientId}
                                                              harvestProjectId={data.harvestProject.id}
                                                              harvestProjectName={data.harvestProject.name}
                                                              onChangeMethod={harvestFieldChange}/>
                                    </Grid>
                                    <Grid item xs={12} data-testid='JiraBoardSearchBox'>
                                        <JiraProjectSearch jiraProjectId={data.jiraProject.id}
                                                           jiraProjectName={data.jiraProject.name}
                                                           onChangeMethod={jiraFieldChange}/>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                elevation={2}
                                className="cardWidth"
                                style={{
                                    height: "560px",
                                }}
                            >
                                <div className="HeadingTypography">Project Details</div>
                                <div className={"progressSpinner"} id={"progressSpinner"} hidden={!isShowSpinner}>
                                    <CircularProgress data-testid={"circleProgress"}/>
                                </div>
                                <Grid container direction="column" hidden={isShowSpinner} justifyContent={"flex-start"}
                                      alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding" id={"projectDetailsBox"}>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                Project type
                                            </InputLabel>
                                        <Select
                                            sx={style}
                                            MenuProps={MenuProps}
                                            id="projectType"
                                            value={projectTypeValue}
                                            select
                                            label="Project type"
                                            name="projectType"
                                            onChange={e => fieldsOnChange(e)}
                                        >
                                            {projectType.map((option) => (
                                                <MenuItem key={option.value} value={option.value} className={"hoverItems"}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            disabled
                                            id="startDate"
                                            label="Start date"
                                            defaultValue="Start date"
                                            name="startDate"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            disabled
                                            id="endDate"
                                            label="End date"
                                            defaultValue="End date"
                                            name="endDate"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            disabled
                                            id="timeRetainer"
                                            label="Time retainer"
                                            defaultValue="Time retainer"
                                            name="timeRetainer"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                        <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                            Roll over rules
                                        </InputLabel>
                                        <Select
                                            onChange={DisplayRollOverRules}
                                            sx={style}
                                            id="RollOverRules"
                                            value={rollOverRulesValue}
                                            select
                                            input={<OutlinedInput label="Roll over rules"/>}
                                            MenuProps={MenuProps}
                                            name="rollover"
                                            label={"Roll over rules"}
                                        >
                                            {
                                                rollOverRules.map((option) => (
                                                    <MenuItem key={option.value} value={option.value} className={"hoverItems"}
                                                              style={getStyles(option.label, personName, theme)}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} id="showExpiryTypeDiv">
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                Expiry type
                                            </InputLabel>
                                        <Select
                                            sx={style}
                                            id="expiryType"
                                            select
                                            value={expiryDateValue}
                                            MenuProps={MenuProps}
                                            input={<OutlinedInput label="Expiry type"/>}
                                            name="expiryType"
                                            onChange={e => fieldsOnChange(e)}
                                        >
                                            {expiryType.map((option) => (
                                                <MenuItem key={option.value} value={option.value} className={"hoverItems"}
                                                        style={getStyles(option.label, personName, theme)}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} id="showRollOverHoursDiv" style={{display: "none"}}>
                                        <Stack direction="row" spacing={1.5}>
                                            <FormControl sx={style} style={{width: "41%",}}>
                                                <InputLabel id="demo-multiple-name-label">
                                                    Roll over hours type
                                                </InputLabel>
                                            <Select
                                                sx={style}
                                                id="rollOverHoursType"
                                                select
                                                MenuProps={MenuProps}
                                                value={rollOverHoursTypeValue}
                                                label="Roll over hours type"
                                                name="rollOverHoursType"
                                                onChange={e => fieldsOnChange(e)}
                                            >
                                                {rollOverHoursType.map((option) => (
                                                    <MenuItem key={option.value} value={option.value} className={"hoverItems"}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                            <TextField
                                                style={{width: durationWidth}}
                                                sx={style}
                                                id="duration"
                                                label="Duration"
                                                variant="outlined"
                                                type="number"
                                                name="duration"
                                                onChange={e => fieldsOnChange(e)}
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                className="cardWidth"
                                elevation={3}
                                style={{
                                    height: "400px",
                                }}
                            >
                                <div className="HeadingTypography">Alert rules</div>
                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="alertThreshold"
                                            label="Alert threshold*"
                                            defaultValue="Alert threshold*"
                                            variant="outlined"
                                            type="number"
                                            InputProps={{
                                                inputProps: {min: 0, max: 100},
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                            }}
                                            InputLabelProps={{shrink: true,}}
                                            name="alertThreshold"
                                            onChange={e => fieldsOnChange(e)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                Who do I notify?
                                            </InputLabel>
                                            <Select
                                                labelId="demo-multiple-name-label"
                                                id="demo-multiple-name"
                                                multiple
                                                value={personName}
                                                onChange={NotifyHandleChange}
                                                input={<OutlinedInput label="Who do I notify?"/>}
                                                MenuProps={MenuProps}
                                                name="notifyee"
                                            >
                                                {notify.map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}
                                                        className={"hoverItems"}
                                                        style={getStyles(option.label, personName, theme)}
                                                    >
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl sx={style} className="inputWidth">
                                            <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                Invoicing rule
                                            </InputLabel>
                                        <Select
                                            sx={style}
                                            id="invoicingRule"
                                            MenuProps={MenuProps}
                                            input={<OutlinedInput label="Invoicing rule"/>}
                                            select
                                            value={invoicingRuleValue}
                                            name="invoicingRule"
                                            onChange={ShowInvoicingRule}
                                        >
                                            {invoicingRule.map((option) => (
                                                <MenuItem key={option.value} value={option.value}
                                                          className={"hoverItems"}
                                                        style={getStyles(option.label, personName, theme)}>
                                                    {option.label}
                                                </MenuItem>
                                            ))
                                            }
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} id="daysInArrearsDiv" style={{display: "none"}}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="Arrears"
                                            label="Days in arrears (1-29)"
                                            variant="outlined"
                                            type="number"
                                            name="daysInArrears"
                                            onChange={CheckArrearDays}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                className="cardWidth"
                                elevation={4}
                                style={{
                                    height: "294px",
                                }}
                            >
                                <div className="HeadingTypography">Agreements & Documents</div>
                                <DragAndDrop inputUpdated={() => {console.log("document added")}}/>
                            </Paper>
                        </Box>
                        <Box style={{marginTop: "20px"}} xs={12}>
                            <Paper
                                className="cardWidth" style={{backgroundColor: "#F6F6F6", border: "0"}}>
                                <div className="d-inline-block float-end buttonPadding saveButtonPadding">
                                    <Stack data-testid='InnerStack' direction="row" spacing={stackSpace2}>
                                        <Tooltip disableHoverListener={enableSave}
                                                 title={"Save button disabled if there are no changes made"}>
                                            <span>
                                                <button
                                                    type="submit"
                                                    variant="contained"
                                                    className="SaveButton"
                                                    onClick={() => {
                                                        setSaveClicked(true);
                                                    }}
                                                    disabled={!enableSave}
                                                >
                                                    {" "}
                                                    SAVE
                                                </button>
                                            </span>
                                        </Tooltip>
                                    </Stack>
                                </div>
                                <div className="d-inline-block float-end buttonPadding cancellButtonPadding">
                                    <button
                                        className="CancelButton"
                                        variant="outlined"
                                        onClick={() => {
                                            setOpenModal(true);
                                            setSaveClicked(false);
                                        }}>
                                        CANCEL
                                    </button>

                                    <CancelModal
                                        open={openModal}
                                        onClose={() => setOpenModal(false)}
                                    />
                                </div>
                            </Paper>
                        </Box>
                    </Grid>
                </form>
            </div>
        </div>
    );
};

export default AddServiceRequest;

